import api from './api';

export function changePassword(currentPassword, newPassword) {
    return api.post('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
    });
}
